import { Box, Typography } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import { BoxRow } from 'components/Tasks/style'
import { DensityStyleTypes } from 'types'
import { formatDateString, formatDateTime } from 'utils/formatDayjsDateTime'
import DateCell from 'components/MTB/grid/cells/DateCell'
import { getDensityStyles } from 'components/DataGrid/operators/getDensityStyles'
import NotesTooltip from './cells/NotesTooltip'
import OptsOrgCell from './cells/OptsOrgCell'

const renderOptimizationsColumns = (handleRowClick: (orgId: string) => void): GridColDef[] => {
  const densityStyles: DensityStyleTypes = getDensityStyles('compact')
  return [
    {
      field: 'name',
      aggregable: false,
      headerName: 'Name',
      width: 225,
      valueGetter: (_, row) => row?.name,
      renderCell: (params: GridRenderCellParams) => (
        <BoxRow>
          <Typography sx={{ color: params?.row?.color ?? 'text.primary', fontSize: densityStyles.fontSize }}>
            {params?.value}
          </Typography>
        </BoxRow>
      ),
    },
    {
      field: 'organization',
      aggregable: false,
      headerName: 'Organization Name',
      width: 250,
      // flex: 1,
      valueGetter: (_, row) => {
        return row?.organization?.name
      },
      renderCell: (params: GridRenderCellParams) => {
        return <OptsOrgCell params={params} densityStyles={densityStyles} handleRowClick={handleRowClick} />
      },
    },
    {
      field: 'type',
      aggregable: false,
      headerName: 'Type',
      width: 250,
      valueGetter: (_, row) => row?.type,
      renderCell: (params: GridRenderCellParams) => (
        <BoxRow>
          <Typography
            sx={{
              color: params?.value ? renderColorByString(params?.value?.toUpperCase()) : 'text.primary',
              fontSize: densityStyles.fontSize,
            }}
          >
            {params?.value ? params?.value?.toUpperCase() : 'N/A'}
          </Typography>
        </BoxRow>
      ),
    },
    {
      field: 'addtlNotes',
      aggregable: false,
      headerName: 'Notes',
      width: 350,
      valueGetter: (_, row) => row?.addtlNotes,
      renderCell: params => {
        // return <DescriptionTooltipLabel content={params.value || ''} onClick={() => {}} isDraft={true} />
        return (
          <BoxRow>
            <NotesTooltip content={params.value || ''} />
            <Box
              sx={{
                display: '-webkit-box',
                width: '100%',
                lineHeight: 1.6,
                fontSize: densityStyles.fontSize,
                '& p': { mb: 1 },
                '& ul': { pl: 3, mb: 1 },
                '& li': { mb: 0.5 },
                '& strong': { fontWeight: 'bold', fontSize: 16 },
                '& span[style]': { display: 'inline' },
                textAlign: 'left',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                //
                borderRadius: 1,
                p: 1,
              }}
              dangerouslySetInnerHTML={{
                __html:
                  params.value && params.value !== '<p></p>'
                    ? params?.value
                    : `<p style="margin-top: 2px; color: ;">No notes</p>`,
              }}
            />
          </BoxRow>
        )
      },
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      width: 180,
      valueGetter: (_, row) => {
        return row?.createdAt ? formatDateTime(row?.createdAt) : null
      },
      renderCell: (params: GridRenderCellParams) => (
        <DateCell date={params?.value} params={params} densityStyles={densityStyles} />
      ),
    },
    {
      field: 'followDate',
      headerName: 'Follow Up',
      width: 180,
      valueGetter: (_, row) => {
        return row?.followDate ? formatDateString(row?.followDate) : null
      },
      renderCell: (params: GridRenderCellParams) => (
        <DateCell date={params?.value} params={params} densityStyles={densityStyles} />
      ),
    },
  ]
}

export default renderOptimizationsColumns
